import { useRef } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { changeLanguage } from "./textTranslate/i18n.js"
import Cookies from 'js-cookie'

import Layout from "./pages/Layout";

import "primereact/resources/primereact.min.css"
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import "./styles/theme.css"
import './styles/style.css'
import './App.css'

import AddCurrency from "./pages/Setup/Currency/AddCurrency";
import EditCurrency from "./pages/Setup/Currency/EditCurrency";
import AddGroup from "./pages/Setup/Group/AddGroup.jsx";
import EditGroup from "./pages/Setup/Group/EditGroup";
import AddIndustry from "./pages/Setup/Industry/AddIndustry/AddIndustry";
import EditIndustry from "./pages/Setup/Industry/EditIndustry/EditIndustry";
import AddProductName from "./pages/Setup/ProductName/AddProductName";
import EditProductName from "./pages/Setup/ProductName/EditProductName";
import AddSpecification from "./pages/Setup/Specification/AddSpecification";
import EditSpecification from "./pages/Setup/Specification/EditSpecification";
import AddState from "./pages/Setup/State/AddState";
import EditState from "./pages/Setup/State/EditState";
import AddMenu from "./pages/Setup/Menu/AddMenu";
import EditMenu from "./pages/Setup/Menu/EditMenu";
import AddUom from "./pages/Setup/UOM/AddUom";
import EditUom from "./pages/Setup/UOM/EditUom";
import CountryList from "./pages/Setup/Country/CountryList";
import BrandList from "./pages/Setup/Brand/BrandList";
import AddBrand from "./pages/Setup/Brand/AddBrand";
import EditBrand from "./pages/Setup/Brand/EditBrand";

import CompanyAdd from "./pages/Company/CompanyAdd";

import AddCompanyBranch from "./pages/Branch/AddCompanyBranch"

import AddCompanyUsers from "./pages/Branch/BranchUser"

import EditUser from "./pages/EditUser"
import ListUser from "./pages/ListUser"

import PostRequirement from "./pages/PostRequirement"
import IndustryList from "./pages/Setup/Industry/IndustryList";
import ProductNameList from "./pages/Setup/ProductName/ProductNameList";
import SpecificationList from "./pages/Setup/Specification/SpecificationList";
import MaterialMaster from './pages/MaterialMaster'

import StateList from "./pages/Setup/State/StateList";
import UomList from "./pages/Setup/UOM/UomList";
import MenuList from "./pages/Setup/Menu/MenuList";
import GroupList from "./pages/Setup/Group/GroupList";
import CurrencyList from "./pages/Setup/Currency/CurrencyList";

import SendRequisition from "./pages/SendRequisition";
import BranchUser from "./pages/Branch/BranchUser";
import AuditProduct from "./pages/AuditProduct";

import PasswordReset from './pages/Login/components/passwordReset'
import GoogleRedirect from './pages/Login/components/googleRedirect'
import MicrosoftRedirect from './pages/Login/components/microsoftRedirect'
import GoogleSendMailRedirect from "./common/googleSendMailRedirect";

import CatalogueRequest from "./pages/SAP/index.jsx";
import CompanyList from "./pages/Company/CompanyList";
import Login from "./pages/Login/";
import CompanyBankDetails from "./pages/CompanyBankDetails";

import PettyCash from "./pages/PettyCash";
import PettyCashAccounts from "./pages/PettyCashAccounts";
import CompanyEdit from "./pages/Company/CompanyEdit";
import { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { fetchUserRoles, setLoading } from './services/redux/reducers/user/user'

import PIWiseInvoiceBooking from "./pages/PIWiseInvoiceBooking";
import SellerDebitNoteBooking from "./pages/SellerDebitNoteBooking";
import BuyerDebitNoteBooking from "./pages/BuyerDebitNoteBooking";
import BuyerPO from "./pages/BuyerPO";
import DocViewByDocNo from "./common/DocViewByDocNo"
import BuyerQuotationDocument from "./pages/BuyerQuatationDocument";
import SellerPO from "./pages/SellerPO"

import BuyerRateContract from "./pages/BuyerRateContract/index";

import { logoutChannel } from "./common/logoutChannel";

import DebitNote from "./pages/DebitNote";

import InvoiceDocumentNew from "./pages/InvoiceDocumentNew";
import VendorPaymentSummary from "./pages/VendorPaymentSummary";
import VendorPaymentCreditNonCredit from "./pages/VendorPaymentCreditNonCredit";
import VendorPaymentCheque from "./pages/VendorPaymentCheque";
import CashFlow from "./pages/CashFlow";
import VendorPaymentPettyCash from "./pages/VendorPaymentPettyCash";
import OpenPO from "./pages/OpenPO/index.jsx";
import DeveloperConsole from './pages/DeveloperConsole/';
import ApprovalInstances from './pages/ApprovalInstances/'
import ChequeBook from "./pages/ChequeBook";
import VendorPayment from "./pages/VendorPayment";
import CashFlowTracker from "./pages/CashFlowTracker/index.jsx";
import TicketList from  "./pages/tickets/index.jsx"
import TicketAdd from "./pages/tickets/TicketAdd.jsx"
import TicketEdit from './pages/tickets/TicketEdit.jsx'
import GenerateEwayBill from "./pages/GenerateEwayBill/index.jsx";
import EwayBillDocument from "./pages/EwayBillDocument/index.jsx";

import CreditNoteDocument from "./pages/CreditNoteDocument/index.jsx";
import DeliveryChallan from "./pages/DeliveryChallan/index.jsx";
import OrderHistory from "./pages/OrderHistory/index.jsx";
import PageNotFound from "./common/PageNotFound.jsx";
import UserNotAllowed from "./common/UserNotAllowed.jsx";
import StockMovement from "./pages/StockMovement/index.jsx";
import StockSnapshot from "./pages/StockSnapshot/index.jsx";
import StockReport from "./pages/StockReport/index.jsx";
import StockAdjustment from "./pages/StockAdjustments/index.jsx";
import Voucher from "./pages/Voucher/index.jsx";
import PMBranch from "./pages/PMBranch/index.jsx";
import Permissions from "./pages/Permissions/index.jsx";
import SellerSearch from "./pages/SellerSearch/index.jsx"
import SellerCompany from "./pages/SellerCompanyProfile/index.jsx";
import ProformaInvoice from "./pages/ProformaInvoice";
import TableauDashboard from "./pages/TableauDashboard"
import AdminAccountsBuyer from "./pages/AdminAccountsBuyer/index.jsx";

import MaterialManufacture from "./pages/MaterialManufacture"
import NewRequirementBuyer from "./pages/NewRequirementBuyer";
import VendorRateContract from "./pages/VendorRateContract";
import FollowUp from "./pages/Warehouse/FollowUp/index.jsx";
import Inward from "./pages/Warehouse/Inward/index.jsx"
import Dispatch from "./pages/Warehouse/Dispatch/index.jsx";
import VMI from "./pages/VMI/index.jsx";

import BuyerPortalRateContract from "./pages/BuyerPortal/RateContract/index.jsx";
import BuyerPortalConsumerRequest from "./pages/BuyerPortal/ConsumerRequest/index.jsx";

import BuyerPortalBuyerDashboard from "./pages/BuyerPortal/BuyerDashboard/index.jsx";
import BuyerPortalBuyerPurchaseOrder from "./pages/BuyerPortal/BuyerPurchaseOrder/index.jsx";
import BuyerInvoiceHistory from "./pages/BuyerPortal/Invoices/index.jsx"
import BuyerConsumerHistory from "./pages/BuyerPortal/ConsumerHistory/index.jsx"
import AdminMessageNotification from "./pages/AdminMessageNotification/index.jsx";
import BuyerOrderHistory from "./pages/BuyerPortal/BuyerOrderHistory/index.jsx";
import ApprovalsChart from "./pages/ApprovalsChart/index.jsx";

import OrganizationHierarchy from "./pages/OrganizationHierarchy/index.jsx";

import { getPMCompanyConfig } from "./setup/pmCompanyConfig.js";
import { socket } from "./services/socket/socket.js";
import setupSocketListeners from "./services/socket/setupSocketListeners.js";
import Toast from "./common/Toast.jsx";
import Ariba from "./pages/BuyerPortal/Ariba/index.jsx";

import ProcessLines from "./pages/ProcessLines/index.jsx";
import PIWiseInvoiceVerification from "./pages/PIWiseInvoiceVerification";
import StockReportRaw from "./pages/StockReportAging/index.jsx";
import { ErrorBoundary, startBufferedRecording, stopRecording } from "./ErrorBoundary.jsx";
import ErrorDashboard from "./pages/ErrorDashboard/index.jsx";


function App() {
	const dispatch = useDispatch()
	const jwtToken = Cookies.get('jwtTokenClient')
	
	const userDetails = useSelector((state) => state.userDetails)
	const activeRoleId = useSelector((state) => state.userDetails.activeRoleId)
	const PMCompanyDetails = useSelector((state) => state.userDetails.PMCompanyDetails)

	useEffect(() => {
		if (activeRoleId) {
			socket.emit('identify', userDetails.userId)

			setupSocketListeners(socket)
        }
	},[activeRoleId])

	useEffect(() => {
		startBufferedRecording()

		if (jwtToken) {
			dispatch(fetchUserRoles())
		} else {
			dispatch(setLoading(false))
		}
		logoutAllTabs()
	}, [])

	useEffect(() => {
		const PMCompanyConfig = getPMCompanyConfig(PMCompanyDetails.companyId)
		changeLanguage(PMCompanyConfig.defaultLanguage)
	}, [activeRoleId])

	const logoutAllTabs = () => {
		logoutChannel.onmessage = async () => {
			window.location.href = '/'
			logoutChannel.close()
		}
	}

	return (
		<>
			<Toast />
			<BrowserRouter>
				<ErrorBoundary 
					userId={userDetails.userId}
					fallback={<div className="p-4 text-red-500">Oops! An unexpected error occurred.</div>}
					onError={(error, info) => {
						stopRecording();
						console.warn('Custom error handler:', error, info)
					}}
				>
				<Routes>
					<Route path="/login" element={<Login />} />
					<Route path="/password-reset/:id" element={<PasswordReset />} />
					<Route path="/google-redirect" element={<GoogleRedirect />} />
					<Route path="/microsoft-redirect" element={<MicrosoftRedirect />} />
					<Route path="/googleemailredirect" element={<GoogleSendMailRedirect />} />

					<Route path="/" element={<Layout />} >

						{/* Company Branch */}
						<Route path="/company/branches/:id" element={<AddCompanyBranch />} />

						{/* Company Users */}
						<Route path="/addcompanyusers/:id" element={<AddCompanyUsers />} />

						{/* Buyer Rate Contract */}
						<Route path="/company/ratecontract/:id" element={<BuyerRateContract />} />

						{/* User */}
						<Route path="/edituser/:userId" element={<EditUser />} />
						<Route path="/listuser" element={<ListUser />} />

						{/* Post Requirements */}
						<Route path="/postrequirement" element={<PostRequirement />} />
						<Route path="/postrequirement/:buyerReqId" element={<PostRequirement />} />

						{/* MaterialMaster */}
						<Route path="/materialmaster" element={<MaterialMaster />} />

						{/* Setup */}
						<Route path="/setup" >
							<Route index element={<CountryList />} />
							<Route path="country" element={<CountryList />} />
							<Route path="state/add" element={<AddState />} />
							<Route path="state/edit/:id" element={<EditState />} />
							<Route path="brand" element={<BrandList />} />
							<Route path="brand/add" element={<AddBrand />} />
							<Route path="brand/edit/:id" element={<EditBrand />} />
							<Route path="industry" element={<IndustryList />} />
							<Route path="industry/add" element={<AddIndustry />} />
							<Route path="industry/edit/:id" element={<EditIndustry />} />
							<Route path="state" element={<StateList />} />
							<Route path="state/add" element={<AddState />} />
							<Route path="state/edit/:id" element={<EditState />} />
							<Route path="product-name" element={<ProductNameList />} />
							<Route path="product-name/add" element={<AddProductName />} />
							<Route path="product-name/edit/:id" element={<EditProductName />} />
							<Route path="uoms" element={<UomList />} />
							<Route path="uoms/add" element={<AddUom />} />
							<Route path="uoms/edit/:id" element={<EditUom />} />
							<Route path="specification" element={<SpecificationList />} />
							<Route path="specification/add" element={<AddSpecification />} />
							<Route path="specification/edit/:id" element={<EditSpecification />} />
							<Route path="currency" element={<CurrencyList />} />
							<Route path="currency/add" element={<AddCurrency />} />
							<Route path="currency/edit/:id" element={<EditCurrency />} />
							<Route path="menu" element={<MenuList />} />
							<Route path="menu/add" element={<AddMenu />} />
							<Route path="menu/edit/:id" element={<EditMenu />} />
							<Route path="group" element={<GroupList />} />
							<Route path="group/add" element={<AddGroup />} />
							<Route path="group/edit/:id" element={<EditGroup />} />
						</Route>

						<Route path="company" >
							<Route path="add" element={<CompanyAdd />} />
							<Route path=":id" element={<CompanyEdit />} />
							<Route path="list" element={<CompanyList />} />
						</Route>
						<Route path="company/bank_details/:id" >
							<Route path="" element={<CompanyBankDetails />} />
						</Route>

						<Route>
							<Route path="/send_requisition/:buyerReqId" element={<SendRequisition />} />
						</Route>
						<Route>
							<Route path="/company/users/:id" element={<BranchUser />} />
						</Route>

						<Route path="/audit-product/:buyerReqId" element={<AuditProduct />} />
						<Route path="/buyerquote/:buyerQuoteId" element={<AuditProduct />} />


						<Route path="/requirement" element={<NewRequirementBuyer />} />


						<Route path="/send-message" element={<AdminMessageNotification />} />

						<Route>
							<Route path="/pettycash" element={<PettyCash />} />
						</Route>
						<Route>
							<Route path="/pettycash-accounts" element={<PettyCashAccounts />} />
						</Route>
						
						{/* Finanace-Route */}
						<Route>
							<Route path="/piwise_invoice_booking" element={<PIWiseInvoiceBooking />} />
						</Route>
						<Route>
							<Route path="/seller_debitnote_booking" element={<SellerDebitNoteBooking />} />
						</Route>
						<Route>
							<Route path="/buyer_debitnote_booking" element={<BuyerDebitNoteBooking />} />
						</Route>
						<Route>
							<Route path="/buyerpo/:buyerPOId" element={<BuyerPO />} />
						</Route>
						<Route>
							<Route path="/docs/:docNo" element={<DocViewByDocNo />} />
						</Route>
						<Route>
							<Route path="/consumer-request" element={<BuyerPortalConsumerRequest />} />
						</Route>
						<Route>
							<Route path="/catelogue_request/:branchId" element={<Ariba />} />
						</Route>
						<Route>
							<Route path="/buyer/quotation/:buyerQuoteId" element={<BuyerQuotationDocument />} />
						</Route>
						<Route>
							<Route path="/sellerpo/:sellerPOId" element={<SellerPO />} />
						</Route>

						<Route path="/debitnote/:adjustmentNoteId" element={<DebitNote />} />
						

						<Route path="/warehouse/followup" element={<FollowUp />} />

						<Route path="/warehouse/inward" element={<Inward />} />

						<Route path="/warehouse/dispatch" element={<Dispatch />} />

						<Route path="/buyerInvoice/:buyerInvoiceId" element={<InvoiceDocumentNew />} />

						<Route path="/vendor_payment" element={<VendorPayment />} />

						<Route path="/vendor_payment_summary/:sellerPOId" element={<VendorPaymentSummary />} />

						<Route path="/vendor_payment_credit_non_credit" element={<VendorPaymentCreditNonCredit />} />

						<Route path="/vendor_payment_cheque" element={<VendorPaymentCheque />} />

						<Route path="/vendor_payment_petty_cash" element={<VendorPaymentPettyCash />} />

						<Route path="/cash_flow" element={<CashFlow />} />
						<Route path="/openpo" element={<OpenPO />} />

						<Route path="/buyer-rate-contract" element={<BuyerPortalRateContract />} />

						<Route path="/admin_accounts_buyer" element={<AdminAccountsBuyer />} /> 
						<Route path="/developer-console" element={<DeveloperConsole />} />
						<Route path="/chequebook" element={<ChequeBook />} />
						<Route path="/cash_flow_tracker" element={<CashFlowTracker />} />
						<Route path="/pm_branch" element={<PMBranch />} />
            			<Route path="/approvals" element={<ApprovalInstances/>} />
            			<Route path="/approvals-chart" element={<ApprovalsChart	/>} />


            			<Route path="/tickets" element={<TicketList/>} />
            			<Route path="/tickets/add" element={<TicketAdd/>} />
            			<Route path="/tickets/edit/:id" element={<TicketEdit/>} />

						<Route path="/Eway_bill_document/:ewayBillId" element={<EwayBillDocument />} />

						<Route path="/generate_eway_bill/:id" element={<GenerateEwayBill />} />

						<Route path="/credit_note/:adjustmentNoteId" element={<CreditNoteDocument />} />

						<Route path="/buyer-debit-note/:adjustmentNoteId" element={<CreditNoteDocument />}/>

						<Route path="/buyer_portal_buyer_dashboard" element={<BuyerPortalBuyerDashboard />} />
						
						<Route path="/delivery_challan/:deliveryChallanId" element={<DeliveryChallan />} />

						<Route path="/order-history" element={<OrderHistory />} />

						<Route path="/buyer-portal-buyer-purchase-order" element={<BuyerPortalBuyerPurchaseOrder />} />
						<Route path="/buyer-order-history" element={<BuyerInvoiceHistory />} />
						<Route path="/buyer-consumer-history" element={<BuyerConsumerHistory />} />
						
						<Route path="/buyer-po-history" element={<BuyerOrderHistory />} />

						
						<Route path="/stock_movement" element={<StockMovement />} />

						<Route path="/stock_snapshot" element={<StockSnapshot />} />

						<Route path="/stock_report" element={<StockReport /> } />

						<Route path="/permissions" element={<Permissions /> } />

						<Route path="/stock_adjustment" element={<StockAdjustment /> } />

						<Route path="/voucher/:pettyCashId" element={<Voucher />} />
						<Route path="/proforma_invoice/:proformaInvoiceId" element={<ProformaInvoice />} />

						<Route path="/seller-search" element={<SellerSearch />} />
						<Route path="/tableau-dashboard" element={<TableauDashboard />} />
						<Route path="/material-manufacture" element={<MaterialManufacture />} />

						<Route path="/company/seller-profile/:id" element={<SellerCompany />} />

						<Route path="/vendor-rate-contract" element={<VendorRateContract/> } />

						<Route path="/vmi" element={<VMI />} />
						<Route path="/organisation-chart" element={<OrganizationHierarchy />} />

						<Route path="/process-lines" element={<ProcessLines />} />
						<Route path="/piwise_invoice_verification" element={<PIWiseInvoiceVerification />} />

						<Route path="/stock-report" element={<StockReportRaw/> } />
						
						<Route path="/error-dashboard" element={<ErrorDashboard />} />	
					</Route>
					<Route path="/404" element={<PageNotFound />} />
					<Route path="/403" element={<UserNotAllowed />} />
				</Routes>
				</ErrorBoundary>
			</BrowserRouter>
		</>
	);
}

export default App;
